import TransporterType from './TransporterType';

export default class Transporter {
    public transporterId: number = 0;
    public name: string = '';
    public transporterTypeId: number = 0;
    public transporterType: TransporterType = new TransporterType();
}
